module.exports = __webpack_public_path__ + "img/rondorff.437156d0.jpg";